import React from 'react'

export default function NoMatch() {
  return (
    <div>
      <h2>Not found</h2>
    </div>
  )
}
